import { cn, InvoicingFeatureName } from '@jobcost-monorepo/utils';
import { useTranslation } from 'react-i18next';

export interface SubListProps {
  label: string;
  navigateTo: string;
  adminOnly?: boolean;
  /** Voce visibile solo se la funzione è attiva per il provider di fatturazione. */
  feature?: InvoicingFeatureName;
}

interface Props extends Omit<SubListProps, 'navigateTo'> {
  onClick: () => void;
  isSelected: boolean;
}

export default function SublistCard({ label, onClick, isSelected }: Props) {
  const { t } = useTranslation('sidebar');
  return (
    <div className="flex flex-col w-full space-y-1">
      <button
        className="flex w-full py-2 px-1 rounded-lg items-center hover:bg-violet5 dark:hover:bg-violet40"
        onClick={onClick}
      >
        <span
          className={cn(
            'flex-1 flex ellipsify pl-1.5',
            isSelected ? 'text-pink' : 'text-black dark:text-white',
          )}
        >
          {t(label)}
        </span>
      </button>
    </div>
  );
}
